module.exports = __webpack_public_path__ + "img/cover_1.3bfc77fd.jpg";